export default __webpack_public_path__ + "static/media/underline_icon_white.50164d46.svg";